import { fontSize_15 } from "../../../shared/styleconfig"
import { ReactComponent as SecureIcon } from '../../../assets/image/icons/secure.svg';
import profilePic from '../../../assets/image/profile/profilePic.png'
import moment from "moment"
import { Button, TextField } from "@mui/material";
import { useState } from "react";
import BuySimmulation from "./BuySimmulation";
import Supabase from "../../../backend/client";
import { useUser } from "../../../context/UserContext";

const getPercentColor = (res) => {
    if(res < 0) {
        return "#FF0000"
    }
    else {
        return "#3AC70F"
    }
}

export const AlgoPopup = ({
    show = false,
    setShowPopup,
    setSelectedAlgo,
    selectedAlgo,
    getMyStocks,
    cart,
    updateStocks,
    setUpdateStocks
}) => {
    const {
        title = '', description = '', status = '', username = '', created_at = new Date(), algo_price = '0', id = '', user_id = ''
    } = selectedAlgo || {}
    const backtestResult = JSON.parse(selectedAlgo?.backtest_details || '{}')
    const user = useUser()
    const [open,setOpen] = useState(false);
    
    
    

    const getButton = (status) => {
        let cartIdsOfUser = cart
        if(cartIdsOfUser.indexOf(id) > -1) {
            return <button className="bg-[#001639] disabled:bg-[#00163950] min-w-[120px] h-[45px] text-white rounded-[25px] text-xs mb-[20px] px-[10px]" disabled>
            Subscribed
        </button>
        }
        else if(status === 'Draft'){
            return <button className="bg-[#001639] min-w-[120px] h-[45px] text-white rounded-[25px] text-xs mb-[20px] px-[10px]" onClick={async () => {
                const { data, error } = await Supabase
                .from('algos')
                .update({ status: 'Publish' })
                .eq('id', selectedAlgo?.id)
                .select()
                setSelectedAlgo(data[0])
                getMyStocks()
                setUpdateStocks(!updateStocks)
            }}>
                    Publish to community
            </button>
         }
         else {
            return <button className="bg-[#001639] disabled:bg-[#00163950] min-w-[120px] h-[45px] text-white rounded-[25px] text-xs mb-[20px] px-[10px]" onClick={() => setOpen(true)} disabled={user?.user?.id === user_id}>
                    Buy: ${algo_price}/m
            </button>
         }
    }
    const mapper = {
        Publish: "Published",
        Draft: "Draft",
        Private: "Private"
    }

    return (
        <div className="fixed w-full h-full bg-[#00000080] top-[0px] left-[0px] z-[101]" style={{
            display: show ? "block" : "none"
        }}>
            <div className="fixed left-[50%] top-[50%] lg:w-[80%] xl:w-[60%] lg:h-[520px] xl:h-[650px] bg-white rounded-[20px] translate-y-[-50%] translate-x-[-50%] flex flex-col z-[1]">
            <div className={`flex flex-1 w-full ${(status === 'Draft' || cart.indexOf(id) > -1 || status === 'Private') ? 'bg-[#0061FC]' : 'bg-[#001639]'} rounded-t-[20px] px-[30px] flex-col justify-between relative`}>
                <div className="flex flex-1 w-full justify-between border-b border-b-solid border-b-white">
                    <div className="flex flex-row gap-[20px] items-center">
                        <img src={ selectedAlgo?.profiles?.avatar_url || profilePic} className="w-[100px] h-[100px] rounded-full"/>
                        <div className="flex flex-col">
                            <p className={`xs:text-[12px] sm:text-[14px]  md:text-[20px] text-white font-[100]`}>{moment(created_at).format('DD/MM/YYYY')}</p>
                            <p className={`xs:text-[15px] sm:text-[22px]  md:text-[25px] text-white font-[700] leading-[25px]`}>Owner: <br />{username}</p>
                        </div>
                    </div>

                    <div className="flex items-center">
                        <div className="flex flex-row gap-[20px] items-start">
                            <div className="text-[15px] text-[#FFEB00] border border-solid border-[#FFEB00] rounded-[10px] w-[90px] text-center h-[30px] mt-[0px] flex items-center justify-center">{mapper[status]}</div>
                            <SecureIcon className="w-[20px] h-auto mt-[4px]"/>
                            <div className="text-white text-[55px]">{backtestResult?.winRate}<sup>%</sup></div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-1 w-full justify-between text-center items-center">
                    <div>
                        <p className="text-[15px] text-white opacity-[0.5]">AV. ANNUAL RETURN</p>
                        <span className="text-white text-[30px]" style={{
                            color: getPercentColor(27)
                        }}>27%</span>
                    </div>
                    <div>
                        <p className="text-[15px] text-white opacity-[0.5]">ANNUAL NET</p>
                        <span className="text-white text-[30px]">$28,000</span>
                    </div>
                    <div>
                        <p className="text-[15px] text-white opacity-[0.5]">WIN RATE</p>
                        <span className="text-white text-[30px]" style={{
                            color: getPercentColor(backtestResult?.winRate)
                        }}>{backtestResult?.winRate}%</span>
                    </div>
                    <div>
                        <p className="text-[15px] text-white opacity-[0.5]">MAX RUN-UP</p>
                        <span className="text-white text-[30px]" style={{
                            color: getPercentColor(32)
                        }}>32%</span>
                    </div>
                    <div>
                        <p className="text-[15px] text-white opacity-[0.5]">MAX RUNDOWN</p>
                        <span className="text-white text-[30px]" style={{
                            color: getPercentColor(-5)
                        }}>-5%</span>
                    </div>
                    <div>
                        <p className="text-[15px] text-white opacity-[0.5]">PROFIT FACTOR</p>
                        <span className="text-white text-[30px]">5.9250</span>
                    </div>
                </div>
                <button className="!bg-[#3285d7] !text-white font-bold w-[20px] h-[20px] rounded-[100%] text-xs absolute right-[10px] top-[10px]" onClick={() => {
                    setSelectedAlgo(null)
                    setShowPopup(false)
                }}>
                    X
                </button>
            </div>
            <div className="flex flex-1 w-full bg-[#ffffff] rounded-b-[20px] px-[30px] flex-row justify-between">
                <div className="flex flex-1 flex-col">
                    <h3 className="text-[25px] text-[#001639] font-bold mt-[25px]">{title}</h3>
                    <p className="text-[15px] text-[#001639] font-[100] pt-[10px]">{description}</p>
                </div>
                <div className="flex flex-1 flex-col justify-between items-end">
                    <p className="mt-[25px] text-right text-[25px] font-bold">${algo_price}/m</p>
                    {
                        getButton(status)
                    }
                </div>
            </div>
        </div>
        {
                open ? 
                <BuySimmulation
                    open={open}
                    handleClose={() => setOpen(false)}
                    algoDetail={selectedAlgo}
                />
                : ""
            }
        </div>
        
    )
}